import VueCookies from 'vue-cookies';
import RfpMctbProvider from './components/rfp-mctb-provider.vue';
import RfpMctbHasVariant from './components/rfp-mctb-has-variant.vue';
import RfpMctbBrand from './components/rfp-mctb-brand.vue';
import RfpMctbProductList from './components/rfp-mctb-product-list/rfp-mctb-product-list.vue';
import RfpMctbError from './components/rfp-mctb-error/rfp-mctb-error.vue';
import RfpMctbEvents from './components/rfp-mctb-events.vue';
import RfpMctbTags from './components/rfp-mctb-tags/rfp-mctb-tags.vue';

import './styles/entry.scss';

export default {
  install(app) {
    const components = [
      RfpMctbProvider,
      RfpMctbHasVariant,
      RfpMctbBrand,
      RfpMctbProductList,
      RfpMctbError,
      RfpMctbEvents,
      RfpMctbTags,
    ];

    if (!app.$cookies) {
      app.use(VueCookies);
    }

    components.forEach((c) => app.component(c.name, c));
  },
};
